
import toggleModalWindow from '@/mixins/toggleModalWindow'

export default {
    mixins: [toggleModalWindow],
}
